import { fromFetch } from 'rxjs/fetch';

import { PagedCollectionParams } from '../../../models/paged-collection-params';
import { requiredHeaders } from '../../../models/required-headers';
import { createPagedCollectionSchema } from '../../../utils/create-paged-collection-schema';
import { selectData } from '../../../utils/select-data';
import { withJwt } from '../../../utils/with-jwt';
import { fleetEnvironment } from '../fleet-environment';
import { avoidFavorSetSchema } from '../schemas/avoid-favor-set.schema';

/**
 * Returns a paginated response for Avoid Favor Sets
 * @param params Paged Collection Params
 * @returns Paged Collection of Avoid Favor Sets
 */
export function getAvoidFavorSets(
  this: unknown,
  params?: PagedCollectionParams
) {
  const requestUrl = `${fleetEnvironment.resolve(this).avoidFavorSetsUrl}?${
    params ? params.urlParams : ''
  }`;
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(requestUrl, {
        method: 'GET',
        headers: {
          ...requiredHeaders,
          ...jwtAuthHeaders,
        },
      })
    )
  ).pipe(selectData(createPagedCollectionSchema(avoidFavorSetSchema)));
}
